import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowsCirclePath = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.02 11.127c.07.5.5.86.99.86v-.01h.14c.54-.08.93-.58.85-1.13-.69-4.97-5.29-8.45-10.27-7.76a9.1 9.1 0 0 0-5.72 3.18v-1.28c0-.55-.45-1-1-1s-1 .44-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H6.2a7.13 7.13 0 0 1 4.81-2.92c3.88-.53 7.47 2.18 8.01 6.06M3.01 13.147c.64 4.55 4.55 7.85 9.02 7.85q.63 0 1.26-.09a9.15 9.15 0 0 0 5.72-3.18v1.28c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1H16c-.55 0-1 .45-1 1s.45 1 1 1h1.81a7.13 7.13 0 0 1-4.81 2.92c-3.88.53-7.47-2.18-8.01-6.06-.08-.54-.58-.93-1.13-.85-.54.08-.93.58-.85 1.13"
    />
  </svg>
);
export default SvgArrowsCirclePath;
